/**************
 Cart
 ***************/

// open cart
async function openCart(skipFetch = false) {
    // open cart
    if (document.querySelector("#miniCart:not([open])")) {
        document.querySelector("#miniCart").showModal();
    }
    document.querySelector("body").classList.add("noScroll");

    // hide all sections
    document.querySelector("#miniCartEmpty").classList.remove("active");
    document.querySelector("#miniCartHeader").classList.remove("active");
    document.querySelector("#miniCartBody").classList.remove("active");
    document.querySelector("#miniCartUpsell").classList.remove("active");
    document.querySelector("#miniCartFooter").classList.remove("active");

    // start loading on the cart
    document.querySelector("#miniCartContent").classList.add("loading");

    // fetch cart
    if (skipFetch === false) {
        cart = await fetch("/cart.js")
            .then(function (data) {
                return data.json();
            });
    }

    // check for the Othership Breathwork App in the cart

    // check if this is the v3 listicle template
    if (pageTemplate.includes('listicle-v3') || pageTemplate.includes('listicle-v4')) {
        let hasOthership = cart.items.find(item => item.variant_id === othershipAppID);
        // create update payload
        let updatePayload = {};

        if (hasOthership) {

            // check how many subscription items are in the cart, including quantity
            let subscriptionItems = 0;
            cart.items.forEach(item => {
                if (item.selling_plan_allocation) {
                    subscriptionItems += item.quantity;
                }
            });

            // if there are no subscription items, remove the Othership Breathwork App Item
            if (!subscriptionItems > 0) {
                updatePayload[othershipAppID] = 0;
            }
            // if there are subscription items, update the quantity to 1
            else if (subscriptionItems > 0 && hasOthership.quantity !== 1) {
                updatePayload[othershipAppID] = 1;
            }

            // check if we need to update the cart
            if (Object.keys(updatePayload).length > 0) {
                cart = await updateCart({updates: updatePayload});
                await openCart(false);
                return;
            }
        } else {
            // check how many subscription items are in the cart, including quantity
            let subscriptionItems = 0;
            cart.items.forEach(item => {
                if (item.selling_plan_allocation) {
                    subscriptionItems += item.quantity;
                }
            });

            if (subscriptionItems === 0) {
                // if the Othership Breathwork App is not in the cart, add it
                // but only if it was called by product-v4
                await addProduct({
                    items: [{
                        quantity: 1,
                        id: othershipAppID
                    }]
                });
            }

            // check if we need to update the cart
            if (Object.keys(updatePayload).length > 0) {
                cart = await updateCart({updates: updatePayload});
                await openCart(false);
                return;
            }
        }
    }
        // if not the v3 listicle template, check if the Othership Breathwork App is in the cart
    // if it is, remove it
    else {
        let hasOthership = cart.items.find(item => item.variant_id === othershipAppID);
        // create update payload
        let updatePayload = {};

        if (hasOthership) {
            // remove the Othership Breathwork App Item
            updatePayload[othershipAppID] = 0;

            // check if we need to update the cart
            if (Object.keys(updatePayload).length > 0) {
                cart = await updateCart({updates: updatePayload});
                await openCart(false);
                return;
            }
        }
    }

    // remove protection or free containers
    const itemsToRemove = cart.items.filter(item => item.variant_id === freeContainerID || item.variant_id === protectionVariantID);
    if (itemsToRemove.length > 0) {
        // create update payload
        let updatePayload = {};

        // get all protection items
        itemsToRemove.forEach(item => {
            updatePayload[item.key] = 0;
        });

        // check if we need to update the cart
        if (Object.keys(updatePayload).length > 0) {
            cart = await updateCart({updates: updatePayload});
            await openCart(true);
            return;
        }
    }

    // stop loading on the cart
    document.querySelector("#miniCartContent").classList.remove("loading");

    //  update cart count in header nav
    if (document.querySelector('#headerCart')) document.querySelector('#headerCart').textContent = `CART (${cart.item_count})`;

    // check for empty cart and EXIT
    if (cart.item_count === 0) {
        document.querySelector("#miniCartEmpty").classList.add("active");
        return;
    }

    // show main cart sections
    document.querySelector("#miniCartHeader").classList.add("active");
    document.querySelector("#miniCartBody").classList.add("active");
    document.querySelector("#miniCartUpsell").classList.add("active");
    document.querySelector("#miniCartFooter").classList.add("active");

    // reset body container
    document.querySelectorAll(".miniCartBodyItem:not(#miniCartBodyFreeContainer)").forEach(element => element.remove());

    // check how many subscription items are in the cart, including quantity
    let subscriptionItems = 0;
    const noFreeContainerForSubscriptionProductIDs = [9875171868954, 9875176718618];
    cart.items.forEach(item => {
        if (item.handle !== "respire-nasal-sticks-mint" && item.selling_plan_allocation && !noFreeContainerForSubscriptionProductIDs.includes(item.product_id)) {
            subscriptionItems += item.quantity;
        }
    });

    // does this order contain a subscription (free shipping)
    if (subscriptionItems > 0) {
        if (window.shipping_ab_test === true) {
            document.querySelector("#miniCartHeaderShipping").innerHTML = "You've unlocked <b>FREE SHIPPING</b><br><span>Your first subscription order ships free!</span>";
        } else {
            document.querySelector("#miniCartHeaderShipping").innerHTML = "You've unlocked <b>FREE SHIPPING</b>";
        }
        document.querySelector("#miniCartHeaderBarInner").classList.add("active");
    } else {
        document.querySelector("#miniCartHeaderShipping").innerHTML = "Upgrade to a subscription for <b>FREE SHIPPING</b>";
        document.querySelector("#miniCartHeaderBarInner").classList.remove("active");
    }

    // show free gifts container
    if (subscriptionItems > 0) {
        // show free container
        document.querySelector("#miniCartBodyFreeContainer").classList.add('active');

        // update free container quantity
        document.querySelector("#miniCartBodyFreeContainer .miniCartBodyItemQuantityCount").textContent = subscriptionItems;

        // update free container price
        document.querySelector("#miniCartBodyFreeContainer .miniCartBodyItemPrice").innerHTML = `
            <s>${price(freeContainerComparePrice * subscriptionItems, false)}</s>
            ${price(0, false)}
            <span>(Save ${price(freeContainerComparePrice * subscriptionItems, false)})</span>
        `;
    } else {
        // hide free container
        document.querySelector("#miniCartBodyFreeContainer").classList.remove('active');
    }

    // update subtotal
    document.querySelector("#miniCartFooterCheckoutPrice").textContent = price(cart.items_subtotal_price);

    // append cart
    cart.items.forEach(function (item) {
        // variant HTML
        function variantHTML() {
            // check for default variant
            if (item.variant_title === null) {
                return "";
            }

            return `<div class="miniCartBodyItemVariant">${item.variant_title}</div>`;
        }

        // subscription HTML
        function subscriptionHTML() {
            if (item.selling_plan_allocation) {
                return `<div class="miniCartBodyItemSellingPlan">${item.selling_plan_allocation.selling_plan.name}</div>`;
            }
            return "";
        }

        // prprotectionVariantIDice HTML
        function priceHTML() {
            let HTML = "";

            /****************** discount ******************/

            let comparePrice = null
            // check for compare at price
            if (variantIDToCompareAtPrice[item.variant_id]) {
                comparePrice = variantIDToCompareAtPrice[item.variant_id] * item.quantity;
            }
            // check if selling_plan_allocation exists, if so append compare_at_price * quantity
            else if (item.selling_plan_allocation) {
                comparePrice = item.selling_plan_allocation.compare_at_price * item.quantity;
            }
            // check for line item discount
            else if (item.original_line_price > item.final_line_price) {
                comparePrice = item.original_line_price;
            }


            // check if comparePrice exists
            if (comparePrice) {
                HTML += `<s>${price(comparePrice, false)}</s>`;
            }

            /****************** actual price ******************/

            HTML += price(item.final_line_price, false);

            /***************** savings *****************/

            // check for savings
            if (comparePrice) {
                let savings = comparePrice - item.final_line_price;
                if (savings > 0) {
                    HTML += `<span>(Save ${price(savings, false)})</span>`;
                }
            }

            return HTML;
        }

        // upgrade button HTML
        function upgradeHTML() {
            // check if already a subscription
            if (item.selling_plan_allocation) {
                return "";
            }

            // get selling plan id and name
            let sellingPlanID = variantIDToSellingPlanID[item.variant_id];
            let sellingPlanName = variantIDToSellingPlanName[item.variant_id];

            // check if selling plan exists
            if (!sellingPlanID) {
                return "";
            }

            // return HTML
            return `
                <button 
                    class="miniCartBodyItemUpgrade button"
                     data-key="${item.key}"
                     data-id="${item.variant_id}" 
                     data-plan="${sellingPlanID}"
                >
                    ${sellingPlanName}
                </button>
            `;
        }

        // insert item
        document.querySelector("#miniCartBody").insertAdjacentHTML("beforeend", `
            <div class="miniCartBodyItem" key="${item.key}">
                <img class="miniCartBodyItemImage" src="${item.image}&width=400">
                <div>
                    <div class="miniCartBodyItemFlex">
                        <div>
                            <div class="miniCartBodyItemTitle">${item.product_title}</div>
                            ${variantHTML()}
                            ${subscriptionHTML()}
                        </div>
                        <button class="miniCartBodyItemRemove">
                            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.28125 3.28125L3.86719 12.6562C3.89502 13.1979 4.28906 13.5938 4.80469 13.5938H10.1953C10.713 13.5938 11.0997 13.1979 11.1328 12.6562L11.7188 3.28125" stroke="#8F8F8F" stroke-width="0.9375" stroke-linecap="round" stroke-linejoin="round"></path><path d="M2.34375 3.28125H12.6562H2.34375Z" fill="#8F8F8F"></path><path d="M2.34375 3.28125H12.6562" stroke="#8F8F8F" stroke-width="0.9375" stroke-miterlimit="10" stroke-linecap="round"></path><path d="M9.60938 5.15625L9.375 11.7188M5.625 3.28125V2.10938C5.62473 2.01697 5.64273 1.92541 5.67797 1.83998C5.71321 1.75455 5.76499 1.67693 5.83034 1.61159C5.89568 1.54624 5.9733 1.49446 6.05873 1.45922C6.14416 1.42398 6.23571 1.40598 6.32812 1.40625H8.67188C8.76429 1.40598 8.85584 1.42398 8.94127 1.45922C9.0267 1.49446 9.10432 1.54624 9.16966 1.61159C9.23501 1.67693 9.28679 1.75455 9.32203 1.83998C9.35727 1.92541 9.37527 2.01697 9.375 2.10938V3.28125H5.625ZM7.5 5.15625V11.7188V5.15625ZM5.39062 5.15625L5.625 11.7188L5.39062 5.15625Z" stroke="#8F8F8F" stroke-width="0.9375" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                        </button>
                    </div>
                    <div class="miniCartBodyItemFlex">
                        <div class="miniCartBodyItemQuantity">
                            <button class="miniCartBodyItemQuantityMinus">-</button>
                            <div class="miniCartBodyItemQuantityCount">${item.quantity}</div>
                            <button class="miniCartBodyItemQuantityPlus">+</button>
                        </div>
                        <div class="miniCartBodyItemPrice">${priceHTML()}</div>
                    </div>
                </div>
                ${upgradeHTML()}
            </div>
        `);
    });

    // event listener for each line item
    document.querySelectorAll(`.miniCartBodyItem:not(#miniCartBodyFreeContainer)`).forEach(function (element) {
        // get key
        let key = element.getAttribute("key");

        // get current quantity
        let quantity = parseInt(element.querySelector(".miniCartBodyItemQuantityCount").textContent);

        // minus
        element.querySelector(".miniCartBodyItemQuantityMinus").addEventListener("click", function () {
            if (quantity === 1) {
                element.querySelector(".miniCartBodyItemRemove").click();
            } else {
                quantity--;
                updateCartItem();
            }
        });

        // plus
        element.querySelector(".miniCartBodyItemQuantityPlus").addEventListener("click", function () {
            quantity++;
            updateCartItem();
        });

        // remove
        element.querySelector(".miniCartBodyItemRemove").addEventListener("click", function () {
            quantity = 0;
            updateCartItem();

            // fade out and remove
            element.classList.add("fade");
            setTimeout(() => {
                element.remove();
            }, 500);
        });

        // update quantity function
        async function updateCartItem() {
            // update label
            element.querySelector(`.miniCartBodyItemQuantityCount`).textContent = quantity;

            // update cart in shopify
            cart = await changeProduct({
                id: key,
                quantity: quantity
            });

            // update active body
            await openCart(true);
        }

        // listen for upgrade button click
        element.querySelector(".miniCartBodyItemUpgrade")?.addEventListener("click", async function () {
            const key = this.dataset.key;
            const variantID = parseInt(this.dataset.id);
            const sellingPlanID = parseInt(this.dataset.plan);

            // add loading animation
            this.classList.add("loading");

            // remove this product from the cart
            await changeProduct({
                id: key,
                quantity: 0,
            });

            // add new product to cart (note, we don't change since we have a custom atc function)
            await addProduct({
                items: [{
                    quantity: 1,
                    id: variantID,
                    selling_plan: sellingPlanID
                }]
            });

            await openCart();

            // remove loading animation
            this.classList.remove("loading");
        });
    });

    // check if cart contains an upsell item
    document.querySelectorAll(".miniCartUpsellItem").forEach(element => {
        // get the product id
        let productID = parseInt(element.dataset.product);

        // check if product exists within the cart
        let isProductInCart = cart.items.find(item => item.product_id === productID);

        // override for listicle v2
        if (cart.items.find(item => item.handle === "listicle-v2-respire-sleep-strips-3-pack")) {
            if (productID === 8558405026074 || productID === 8567567286554) {
                isProductInCart = true;
            }
        }

        // hide if already in the cart
        if (isProductInCart) {
            element.classList.remove("active");
        } else {
            element.classList.add("active");
        }
    });

    // check if all upsells are hidden
    if (document.querySelectorAll(".miniCartUpsellItem.active").length === 0) {
        document.querySelector("#miniCartUpsell").classList.remove("active");
    }

    // add protection price to ATC button if checked
    if (document.querySelector("#miniCartFooterUpsellTopSwitchInput").checked) {
        document.querySelector("#miniCartFooterCheckoutPrice").textContent = price(cart.items_subtotal_price + protectionPrice);
    } else {
        document.querySelector("#miniCartFooterCheckoutPrice").textContent = price(cart.items_subtotal_price);
    }
}

// Add Upsell function
document.querySelectorAll('.miniCartUpsellItemWrapATC').forEach(function (element) {
    element.addEventListener("click", async function () {
        // get variant ID from dropdown selector
        const variantID = this.closest('.miniCartUpsellItem').dataset.variant;

        // add loading animation
        this.classList.add("loading");

        // create form data
        let formData = {
            items: [{
                quantity: 1,
                id: variantID,
            }]
        };

        // check for selling plan
        if (this.closest('.miniCartUpsellItem').dataset.plan) {
            let sellingPlanID = this.closest('.miniCartUpsellItem').dataset.plan;
            formData = {
                items: [{
                    quantity: 1,
                    id: variantID,
                    selling_plan: sellingPlanID
                }]
            };
        }

        // add product upsell
        await addProduct(formData);

        // remove loading animation
        this.classList.remove("loading");

        await openCart();
    });
});

// listen for protection plan switch
document.querySelector("#miniCartFooterUpsellTopSwitchInput").addEventListener("change", async function () {
    await openCart(true);
});

// close cart event
document.querySelector("#miniCart").addEventListener("close", function () {
    document.querySelector("body").classList.remove("noScroll");
});

// close cart
function closeCart() {
    document.querySelector("#miniCart").close();
}

// open cart event listener
document.querySelectorAll(".openCart").forEach(function (element) {
    element.addEventListener("click", function () {
        openCart();
    });
});

//close cart event listener
document.querySelectorAll(".closeCart").forEach(function (element) {
    element.addEventListener("click", closeCart);
});
document.querySelector("#miniCart").addEventListener("click", function (e) {
    if (e.target === this) {
        closeCart();
    }
})

// checkout button loading
document.querySelector("#miniCartFooterCheckout").addEventListener("click", async function () {
    this.classList.add("loading");

    // formdata
    let formData = {
        items: []
    };

    // check how many subscription items are in the cart, including quantity
    let subscriptionItems = 0;
    cart.items.forEach(item => {
        if (item.handle !== "respire-nasal-sticks-mint" && item.selling_plan_allocation) {
            subscriptionItems += item.quantity;
        }
    });

    // add free container
    if (subscriptionItems > 0) {
        await addProduct({
            quantity: subscriptionItems,
            id: freeContainerID,
        });
    }

    // Follow criteria for upsell must be true:
    // 1) Cart value MUST be under $148 for upsell
    // 2) Cart has either 0 subscriptions in the cart or a 1 pack
    // 3) Breathing drops aren't in the cart
    if (
        cart.items_subtotal_price < 12300 &&
        (subscriptionItems === 0 || cart.items.some(item => item.title.includes("1 Pack"))) &&
        !cart.items.some(item => item.handle === "breathing-drops")
    ) {
        //await openUpsell();
    }

    // check if protection product is checked - if so atc
    if (document.querySelector("#miniCartFooterUpsellTopSwitchInput").checked) {
        // add protection product
        await addProduct({
            quantity: 1,
            id: protectionVariantID,
        });
    }

    // remove loading animation
    this.classList.remove("loading");

    // go to checkout
    window.location.href = "/checkout";
});

// register dialog
dialogPolyfill.registerDialog(document.querySelector("#miniCart"));

// check is coming from the cart
if (document.referrer.includes("/cart")) {
    openCart();
}


/**************************** Upsell ****************************/

// Open upsell
async function openUpsell() {
    document.querySelector("#upsell").showModal();
    document.querySelector("body").classList.add("noScroll");


    await new Promise((resolve, reject) => {
        document.querySelector(`#upsell`).addEventListener("close", function (e) {
            resolve('closed');
        });
    });
}

// Upsell ATC
document.querySelector('#upsellContentBodyControlsATC').addEventListener("click", async function () {
    // add loading animation
    this.classList.add("loading");

    // clear cart
    await fetch("/cart/clear.js");

    // create form data
    let formData = {
        items: [{
            quantity: 1,
            id: parseInt(this.dataset.id)
        }]
    };

    // add product upsell
    await addProduct(formData);

    // remove loading animation
    this.classList.remove("loading");

    closeUpsell();
});


// close upsell event
document.querySelector("#upsell").addEventListener("close", function () {
    document.querySelector("body").classList.remove("noScroll");
});

// close upsell
function closeUpsell() {
    document.querySelector("#upsell").close();
}

// close upsell event listener
document.querySelectorAll(".closeUpsell").forEach(function (element) {
    element.addEventListener("click", closeUpsell);
});


document.querySelector("#upsell").addEventListener("click", function (e) {
    if (e.target === this) {
        closeUpsell();
    }
})